<div class="container mt-3">
    <div class="cssmtgb just_center">
        <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab label="SIM">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Manage SIM</span>

                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="col-md-12 d-flex justify-content-between align-items-center flex-wrap">

                            <div class="d-flex align-items-center flex-wrap">
                                <app-button (refreshClicked)="refresh()"></app-button>

                                <button type="button" class="btn excel_btn text-nowrap mr-2"
                                    (click)="exportAsXLSX('SIM_')">
                                    <i class="fa fa-file-excel"></i> Export
                                </button>

                                <button type="button" class="btn excel_btn text-nowrap mr-2"
                                    (click)="importexcel('legalexcelimport','LTE SIM Import')">
                                    <i class="fa fa-file-excel"></i> Import SIM
                                </button>

                            </div>

                            <div class="col-md-4 padd-right-file" style="display: flex;">
                                <form [formGroup]="filterSearchForm" style="display: flex; width: 100%;">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'searchText-mat-field'">
                                        <mat-label>Search</mat-label>
                                        <div class="search-input-container">
                                            <input placeholder="Enter Model / Version / Serial / Mac" id="search"
                                                matInput formControlName="search" type="text" #searchInput
                                                (keyup.enter)="search()">
                                        </div>
                                    </mat-form-field>

                                    <button matSuffix mat-icon-button aria-label="Search"
                                        class="badge bg-light-blue image-button" (click)="search()">
                                        <mat-icon style="color: white;">search</mat-icon>
                                    </button>
                                </form>
                            </div>


                            <button type="button" class="btn btn-primary d-flex align-items-center"
                                (click)="filterOpen = !filterOpen">
                                <ng-container *ngIf="!filterOpen">
                                    <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                                </ng-container>
                                <ng-container *ngIf="filterOpen">
                                    <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                                </ng-container>
                                <span class="ml-2">Filters</span>
                            </button>
                        </div>

                        <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">

                            <div *ngIf="filterOpen" style="overflow: hidden;">
                                <hr>
                                <form [formGroup]="filterSearchForm">
                                    <div class="row mx-5 justify-content-center">
                                        <div class="col-xl-6 mt-4 d-flex justify-content-center">
                                            <mat-form-field appearance="fill" hideRequiredMarker style="width: 50%;">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="status"
                                                    (selectionChange)="filterInventory()">
                                                    <mat-option value="1">Available</mat-option>
                                                    <mat-option value="2">Allocated</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="table-responsive table-container mt-4 mb-4" *ngIf="showcollection">
                            <mat-table #table [dataSource]="dataSource" class="mat-table">
                                <ng-container matColumnDef="Account Number">
                                    <mat-header-cell *matHeaderCellDef>Account Number</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField?.accountNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Username">
                                    <mat-header-cell *matHeaderCellDef> Username</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField?.username}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Password">
                                    <mat-header-cell *matHeaderCellDef>Password</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField?.password}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Sim Number">
                                    <mat-header-cell *matHeaderCellDef>Sim Number</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField?.simNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Package Code">
                                    <mat-header-cell *matHeaderCellDef>Package Code</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign mb-2">
                                            {{dataField?.packageCode}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Package Description">
                                    <mat-header-cell *matHeaderCellDef>Package Description</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 15%;">
                                        <p class="text-truncate txtalign ">
                                            {{dataField?.packageDescription}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Supplier">
                                    <mat-header-cell *matHeaderCellDef>Supplier</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField?.supplier}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Term Date">
                                    <mat-header-cell *matHeaderCellDef>Term Date</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField?.termDate | date:'dd-MMM-yy'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Device Status">
                                    <mat-header-cell *matHeaderCellDef>Device Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{ dataField.deviceStatus === 1 ? 'Available' : (dataField.deviceStatus ===
                                            2 ? 'Allocated' : dataField.deviceStatus) }}
                                        </p>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="simColumns; sticky:true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: simColumns;  " matRipple>
                                </mat-row>
                            </mat-table>
                            <div *ngIf="!dataSource?.data || dataSource.data.length === 0" class="no-data-message">
                                <p>No data found</p>
                            </div>

                        </div>

                        <div class="table_pagenation" [hidden]="!showcollection">
                            <mat-paginator #paginators [length]="dataSource!==null && dataSource.filteredData.length"
                                [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                            </mat-paginator>
                        </div>

                    </div>
                </div>
            </mat-tab>

            <mat-tab label="LTE Router">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">LTE Router</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="col-md-12 d-flex justify-content-between align-items-center flex-wrap">

                            <div class="d-flex align-items-center flex-wrap">
                                <app-button (refreshClicked)="refresh()"></app-button>

                                <button type="button" class="btn excel_btn text-nowrap mr-2"
                                    (click)="exportAsXLSX('LTERouter_')">
                                    <i class="fa fa-file-excel"></i> Export
                                </button>

                                <button type="button" class="btn excel_btn text-nowrap mr-2"
                                    (click)="importexcel('legalexcelimport','LTE Router Import')">
                                    <i class="fa fa-file-excel"></i> Import LTE Routers
                                </button>
                            </div>
                            <div class="col-md-4 padd-right-file" style="display: flex;">
                                <form [formGroup]="filterSearchForm" style="display: flex; width: 100%;">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'searchText-mat-field'">
                                        <mat-label>Search</mat-label>
                                        <div class="search-input-container">
                                            <input placeholder="Enter Model / Version / Serial / Mac" id="search"
                                                matInput formControlName="search" type="text" #searchInput
                                                (keyup.enter)="search()">
                                        </div>
                                    </mat-form-field>

                                    <button matSuffix mat-icon-button aria-label="Search"
                                        class="badge bg-light-blue image-button" (click)="search()">
                                        <mat-icon style="color: white;">search</mat-icon>
                                    </button>
                                </form>
                            </div>


                            <button type="button" class="btn btn-primary d-flex align-items-center"
                                (click)="filterOpen = !filterOpen">
                                <ng-container *ngIf="!filterOpen">
                                    <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                                </ng-container>
                                <ng-container *ngIf="filterOpen">
                                    <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                                </ng-container>
                                <span class="ml-2">Filters</span>
                            </button>
                        </div>

                        <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">

                            <div *ngIf="filterOpen" style="overflow: hidden;">
                                <hr>
                                <form [formGroup]="filterSearchForm">
                                    <div class="row mx-5 justify-content-center">
                                        <div class="col-xl-6 mt-4 d-flex justify-content-center">
                                            <mat-form-field appearance="fill" hideRequiredMarker style="width: 50%;">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="status"
                                                    (selectionChange)="filterInventory()">
                                                    <mat-option value="1">Available</mat-option>
                                                    <mat-option value="2">Allocated</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="table-responsive table-container mt-4 mb-4" *ngIf="showcollection">
                            <mat-table #table [dataSource]="dataSource" class="mat-table">
                                <ng-container matColumnDef="Model">
                                    <mat-header-cell *matHeaderCellDef>Model</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField?.model}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Version">
                                    <mat-header-cell *matHeaderCellDef> Version</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField?.version}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Serial">
                                    <mat-header-cell *matHeaderCellDef>Serial</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                                        <p class="text-truncate txtalign">{{dataField?.serial}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Mac">
                                    <mat-header-cell *matHeaderCellDef>Mac</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign">{{dataField?.mac}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Invoice Number">
                                    <mat-header-cell *matHeaderCellDef>Invoice Number</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign mb-2">
                                            {{dataField?.invoiceNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Supplier">
                                    <mat-header-cell *matHeaderCellDef>Supplier</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField?.supplier}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Date Purchased">
                                    <mat-header-cell *matHeaderCellDef>Date Purchased</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{dataField?.datePurchased | date:'dd-MMM-yy'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Device Status">
                                    <mat-header-cell *matHeaderCellDef>Device Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                                        <p class="text-truncate txtalign py-2">
                                            {{ dataField.deviceStatus === 1 ? 'Available' : (dataField?.deviceStatus ===
                                            2 ? 'Allocated' : dataField?.deviceStatus) }}
                                        </p>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="routerColumns; sticky:true"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: routerColumns;  " matRipple>
                                </mat-row>
                            </mat-table>
                            <div *ngIf="!dataSource?.data || dataSource.data.length === 0" class="no-data-message">
                                <p>No data found</p>
                            </div>
                        </div>
                        <div class="table_pagenation" *ngIf="dataSource.filteredData.length">
                            <mat-paginator #paginators [length]="dataSource!==null && dataSource.filteredData.length"
                                [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>